// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__h6JbR","header":"ReportDetails_header__2huh9","title":"ReportDetails_title__3RoPr","left":"ReportDetails_left__3tAIM"};